import React, { useState, useEffect } from 'react'
import Answer from './Answer'
import Button from '../../partials/Button'
import styles from './Question.module.scss'
import ButtonsHolder from '../Button/ButtonsHolder'

const Question = ({ data, feedback, locked, showSubmit }) => {

    const [answers, setAnswers] = useState([])
    const [nextQuestion, setNextQuestion] = useState()
    const [currentQuestion, setCurrentQuestion] = useState()
    const [showRetry, setShowRetry ] = useState()
    const [lockedAnswer, setLockedAnswer] = useState(false);

    useEffect(() => {

        let initial = {...data}
        let answersCount = initial.answers.filter(answer => answer.correct === true)

        setCurrentQuestion({
            ...initial,
            correctAnswers: answersCount.length
        })
        setNextQuestion(false)

    }, [data, locked])


    const addAnswer = (answers, answer) => {
        const currentAnswers = answers
        currentAnswers.push(answer)
        return currentAnswers

    }
    const removeAnswer = (answers, answer) => {
        return answers.filter(answ => answ.option !== answer.option)
    }
    /**
     * () => 
     * @para(indexm {*} answer 
     * Expects an answer object with prop.selected
     * adds them to the currentAnswers Array
     * in case of completed answers
     * will execute a callback
     */
    const handleAnswers = (selectedAnswer, selectedIndex) => {

        const currentAnswers = currentQuestion.answers.map((answer, index) => {
            return (
                {...answer, selected: ( index === selectedIndex ) ?  selectedAnswer.selected : !!answer.selected }
            )
        })

        const addRemovedAnswers = selectedAnswer.selected ?
             addAnswer(answers, selectedAnswer) : 
             removeAnswer(answers, selectedAnswer)

        setAnswers(addRemovedAnswers)
        setCurrentQuestion({...currentQuestion, answers: currentAnswers })
        setNextQuestion(addRemovedAnswers.length > 0 ? true: false)

        if(!showSubmit) handleContinue()
        
    }


    /**
     * areThey Correct
     * @param {*} answers 
     * @returns obj 
     * Checks if the answers selected are correct
     */
     const areTheyCorrect = (answers) => {
        const allCorrect = answers.every((answer) => answer.correct === true) && answers.length > 0;
        const someCorrect = answers.some((answer) => answer.correct === true)
        const allWrong = !allCorrect && !someCorrect

        
        const feedbackStatus = {
            correct: allCorrect,
            status: allWrong ? 'failed' : allCorrect ? 'success' : 'warning',
        }
        return feedbackStatus
    }

    /**
     * clearAnswes
     * Clears the state for answers and hide the
     * results modal
     */
    const clearAnswers = () => {
        setAnswers([])
    }

    /**
     * handleContinue
     * When the question is correct completes
     * the question and add the correct 
     * answers to the state
     */
    const handleContinue = () => {
        const feedbackStatus = areTheyCorrect(answers)
        const completed = { 
            ...currentQuestion, 
            answers: answers, 
            correct: feedbackStatus.correct,
            status: feedbackStatus.status,
            completed: true 
        }
        clearAnswers([])
        feedback(completed)

    }
    const handleRetry = () =>{
        setAnswers([])
        setShowRetry(false)

    }
    return (
        <>
                {currentQuestion &&
                    <>
                        <div className={styles.question}>
                            <h2>{currentQuestion.label}</h2>
                        </div>

                        <div className={styles.answers}>
                            <div>
                                {currentQuestion.answers.map((answer, index) => {
                                    
                                    return (
                                       <Answer 
                                            key={index}
                                            answer={answer} 
                                            locked={locked}
                                            answerIndex={index} 
                                            callback={handleAnswers}
                                        />
                                    )
                                })}
                            </div>

                        </div>


                    </>
                }

                <ButtonsHolder orientation="center">
                    {showSubmit && <Button
                            text={ currentQuestion?.submitButtonText || "submit" }
                            onClick={handleContinue}
                            className="small"
                        />
                    }
                     {showRetry && <Button
                            text="Retry"
                            onClick={handleRetry}
                            className="small"
                            disabled={!nextQuestion}
                        />
                    }
                </ButtonsHolder>

        </>
    )
}

export default Question
